import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SubscriptionState {
  optInStepPassed: boolean;
  depositStepPassed: boolean;
  optInStepPassedNR: boolean;
  depositStepPassedNR: boolean;
  optedInAddress: string;
  optedInNRAddress: string;
  feedPageSelection: string;
  nodePageSelection: string;
}

const initialState: SubscriptionState = {
  optInStepPassed: false,
  depositStepPassed: false,
  optInStepPassedNR: false,
  depositStepPassedNR: false,
  optedInAddress: '',
  optedInNRAddress: '',
  feedPageSelection: 'about',
  nodePageSelection: 'about',
};

export const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    updateOptedInAddress: (state, action: PayloadAction<string>) => {
      state.optedInAddress = action.payload;
    },
    updateOptedInNRAddress: (state, action: PayloadAction<string>) => {
      state.optedInNRAddress = action.payload;
    },
    updateOptInStepPassed: (state, action: PayloadAction<boolean>) => {
      state.optInStepPassed = action.payload;
    },
    updateDepositStepPassed: (state, action: PayloadAction<boolean>) => {
      state.depositStepPassed = action.payload;
    },
    updateOptInStepPassedNR: (state, action: PayloadAction<boolean>) => {
      state.optInStepPassedNR = action.payload;
    },
    updateDepositStepPassedNR: (state, action: PayloadAction<boolean>) => {
      state.depositStepPassedNR = action.payload;
    },
    updateFeedPageSelection: (state, action: PayloadAction<string>) => {
      state.feedPageSelection = action.payload;
    },
    updateNodePageSelection: (state, action: PayloadAction<string>) => {
      state.nodePageSelection = action.payload;
    },
  },
});

export const {
  updateOptedInAddress,
  updateOptInStepPassed,
  updateDepositStepPassedNR,
  updateDepositStepPassed,
  updateOptInStepPassedNR,
  updateFeedPageSelection,
  updateOptedInNRAddress,
  updateNodePageSelection,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
